module.exports = __webpack_public_path__ + "img/CM-SL-CA-Lincoln-Playful.b1bf6283.jpg";